import './ModalOptions.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import { toast } from "react-toastify";

export class ChangePassword extends Component {
    static displayName = ChangePassword.name;
    state = {
        password: "",
        passwordConfirm: "",
    };


    componentDidMount() {
        //this.getCard();
    }


    doChoice = (e) => {
        e.preventDefault();
/*
        let choice = cardService.getChoiceCard();
        if (choice == []) {
            toast.error('دستگاه فعال مشخص نشده است');;
            return;
        }*/

        //utils.sendSms(choice.deviceNumber, `phone,${this.state.number}`)
        if (this.state.password != this.state.passwordConfirm){
            toast.error('کلمه عبور و تکرار کلمه عبور یکسان نیست');
            return;    
        }
        toast.dark('ثبت شد');
        this.props.closeModal(e);
    }

    render() {
        return (
            <>
                <CustomModal dd="modal-sm" show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="" >

                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">
                                    <div id="ChnageNumberManagerTitle">تغییر رمز</div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="رمز عبور"

                                        value={this.state.password}
                                        onChange={(e) => http.handleChange(e, this)}
                                        className="form-control inputControlModal" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">
                                    <input
                                        type="password"
                                        name="passwordConfirm"
                                        placeholder="رمز عبور"

                                        value={this.state.passwordConfirm}
                                        onChange={(e) => http.handleChange(e, this)}
                                        className="form-control inputControlModal" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                <a onClick={(e) => this.doChoice(e)}>
                                    <img src="images/accept.svg" className="imgButtonModal"></img>
                                </a>
                                    
                                </div>
                            </div>
                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                <a onClick={(e) => this.props.closeModal(e)}>
                                    <img src="images/cancel.svg" className="imgButtonModal"></img>
                                </a>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>
        );
    }


}